/*
 * FSK hero background video — guarded, deferred source-swap.
 * MEDIA-PIPELINE-SPEC §8.4: the poster (<img>) is the LCP and always renders.
 * Video bytes are NEVER fetched until this runs, and are skipped entirely when
 * motion/data should be conserved. No @theme/component coupling on purpose.
 *
 *  - prefers-reduced-motion: reduce  -> poster stays, no fetch
 *  - Save-Data: on                   -> poster stays, no fetch
 *  - effectiveType in slow-2g/2g/3g  -> poster stays, no fetch
 *  - no-JS                           -> poster stays (sources carry only data-src)
 *  - autoplay blocked                -> poster stays (play() promise rejection swallowed)
 */
(function () {
  var video = document.querySelector('video[data-fsk-hero-video]');
  if (!video) return;

  // Reduced motion — never load the clip.
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (rm && rm.matches) return;

  // Connection-aware degrade.
  var conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection || {};
  if (conn.saveData) return;
  var et = conn.effectiveType || '';
  if (et === 'slow-2g' || et === '2g' || et === '3g') return;

  var sources = video.querySelectorAll('source[data-src]');
  if (!sources.length) return;

  // Promote deferred sources, then load + play.
  for (var i = 0; i < sources.length; i++) {
    var el = sources[i];
    var url = el.getAttribute('data-src');
    if (url) el.setAttribute('src', url);
  }

  video.addEventListener('playing', function () {
    video.classList.add('is-playing');
  }, { once: true });

  video.load();
  var playPromise = video.play && video.play();
  if (playPromise && typeof playPromise.catch === 'function') {
    playPromise.catch(function () { /* autoplay blocked — poster remains */ });
  }
})();
